import { AlignTypes } from 'ui/tableHeader';
import { mockBlocks } from 'modules/movableInk/__mocks__';
import { BlockCell } from './BlockCell';
import { MovableInkBlock } from '../../../types';
import { useMovableInkBlockContext } from '../../../contexts/MovableInkBlockContext';
import { useTranslations } from '../../../hooks/useTranslations';
import { defaults } from '../../../constants';
import { useMovableInkCampaignContext } from '../../../contexts/MovableInkCampaignContext';
import { useMovableInkIntegrationContext } from '../../../contexts/MovableInkIntegrationContext';

export const useTableState = () => {
  const { t } = useTranslations();
  const { isFetchingBlocks, selectedBlock, cachedBlocks, blocks } = useMovableInkBlockContext();
  const { isFetchingCampaigns } = useMovableInkCampaignContext();
  const { isFetchingChildIntegrations, isFetchingIntegrations } = useMovableInkIntegrationContext();
  const align: AlignTypes = 'flex-start';

  const loadingRows = Array(defaults.pageSize)
    .fill({})
    .map((_, i) => (
      <BlockCell
        key={`skeleton-block-${i}`}
        block={mockBlocks[0]}
        isLoading={true}
        isSelected={false}
      />
    ));

  const columns = [
    {
      align,
      name: t('panelTable.columns.updated.label'),
      value: 'updated',
      sortable: true,
      width: 352,
      RowCell: ({ row: block }: { row: MovableInkBlock }) => {
        const isSelected = selectedBlock ? block.id === selectedBlock.id : false;
        return (
          <BlockCell
            key={`block_${block.id}`}
            block={block}
            isLoading={isFetchingCampaigns || isFetchingBlocks}
            isSelected={isSelected}
          />
        );
      },
    },
  ];

  const isEmpty =
    !isFetchingIntegrations &&
    !isFetchingChildIntegrations &&
    !isFetchingCampaigns &&
    !isFetchingBlocks &&
    blocks.length === 0 &&
    cachedBlocks.length === 0;

  const isLoading =
    isFetchingIntegrations ||
    isFetchingChildIntegrations ||
    isFetchingCampaigns ||
    isFetchingBlocks;

  return {
    columns,
    rows: cachedBlocks,
    loadingRows,
    isEmpty,
    isLoading,
  };
};
